'use strict';

var index = require('../define-properties/index.js');
var es6 = require('./node_modules/es-abstract/es6.js');
var implementation$1 = require('./implementation.js');
var polyfill$1 = require('./polyfill.js');
var shim$1 = require('./shim.js');

var define = index;
var ES = es6;

var implementation = implementation$1;
var getPolyfill = polyfill$1;
var shim = shim$1;

var slice = Array.prototype.slice;

var polyfill = getPolyfill();

var boundFindShim = function find(array, predicate) { // eslint-disable-line no-unused-vars
	ES.RequireObjectCoercible(array);
	var args = slice.call(arguments, 1);
	return polyfill.apply(array, args);
};

define(boundFindShim, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

var array_prototype_find = boundFindShim;

module.exports = array_prototype_find;
